interface TiptapViewerProps {
  content: string
}

export function TiptapViewer({ content }: TiptapViewerProps) {
  return (
    <div
      className="prose prose-sm max-w-none"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
